import axios from "axios";
import firebase from "../config/firebase";

const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || "fans-help-players";
const baseDomain = `https://us-central1-${projectId}.cloudfunctions.net`;
const baseURL = `${baseDomain}/app`;

const axiosObj = axios.create({
  baseURL,
});

axiosObj.interceptors.request.use(async (config) => {
  const user = firebase.auth().currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => Promise.reject(error));

export default axiosObj;
